import { z } from "zod";
/**
 * PATCH do perfil do próprio colaborador (FASE-06-T33).
 * Só campos PLATAFORMA/HÍBRIDO — sem `internalNotes` (uso exclusivo do RH).
 */
export const patchMeProfileSchema = z
    .object({
    expectedVersion: z.number().int().positive(),
    displayName: z.string().trim().min(1).max(120).nullable().optional(),
    email: z.union([z.string().trim().email().max(320), z.null()]).optional(),
})
    .strict()
    .refine((body) => body.displayName !== undefined || body.email !== undefined, {
    message: "Informe ao menos um campo editável (displayName ou email)",
});
//# sourceMappingURL=patch-me-profile.js.map